import {Presenter} from '../support/with_presenter';
import {TrainingPlan} from '../models/TrainingPlan';
import {v4} from 'uuid';
import {ChangeEvent} from 'react';

export class TrainingPlanSelectorPresenter implements Presenter {
    public searchVisible: boolean = false;

    public selection: TrainingPlan[] = [];

    public get isEmpty(): boolean {
        return this.selection.length === 0;
    }

    constructor(private initialTrainingPlans: TrainingPlan[] | undefined) {
        if (initialTrainingPlans) {
            this.selection = initialTrainingPlans;
        }
    }

    public mount(): void {
        /* Noop */
    }

    public unmount(): void {
        /* Noop */
    }

    public onSearchHide() {
        this.searchVisible = false;
    }

    public onClickSearch() {
        this.searchVisible = true;
    }

    public onSearchSubmit(trainingPlans: TrainingPlan[]) {
        this.searchVisible = false;

        this.selection = [...this.selection, ...trainingPlans];
    }

    public onTrashClick(toBeDeletedTrainingPlan: TrainingPlan) {
        this.selection = [...this.selection.filter((tp) => tp.id !== toBeDeletedTrainingPlan.id)];
    }

    public onSelectionOrderChange(trainingPlans: TrainingPlan[]) {
        this.selection = [...trainingPlans];
    }
}
